var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5814B0F7-C6B1-46E4-9ACB-73665CE82E63") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBule---Milestone-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16.0_Login-Multiple_01",
    transform: "translate(-1091.000000, -318.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(1065.000000, 83.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.Icons-/-Basic-/-Solid-/-User-/-Default-Copy",
    transform: "translate(26.000000, 235.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25,9 C12.9075,9 14.25,7.6575 14.25,6 C14.25,4.3425 12.9075,3 11.25,3 C9.5925,3 8.25,4.3425 8.25,6 C8.25,7.6575 9.5925,9 11.25,9 Z M4.5,7.5 L4.5,5.25 L3,5.25 L3,7.5 L0.75,7.5 L0.75,9 L3,9 L3,11.25 L4.5,11.25 L4.5,9 L6.75,9 L6.75,7.5 L4.5,7.5 Z M11.25,10.5 C9.2475,10.5 5.25,11.505 5.25,13.5 L5.25,15 L17.25,15 L17.25,13.5 C17.25,11.505 13.2525,10.5 11.25,10.5 Z",
    id: "Shape",
    fill: "#8F9BA9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarAddIcon);
export default __webpack_public_path__ + "static/media/AvatarAddIcon.f10cf42997bbe3adbea62ba9f6a65dd2.svg";
export { ForwardRef as ReactComponent };